module.exports = __webpack_public_path__ + "static/media/ga.f2442ae0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ga.svg
// module id = 823
// module chunks = 0